import { render, staticRenderFns } from "./ContratoTagNovo.vue?vue&type=template&id=e49fcb38"
import script from "./ContratoTagNovo.vue?vue&type=script&lang=js"
export * from "./ContratoTagNovo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports